import React from 'react';
import { TFunction } from 'i18next';
import { VisitDtoModelType } from '../../../../store/mst/models';
import ScheduledTo from '../../../shared/ScheduledTo';
import CustomerRating from './CustomerRating';
import Signature from './Signature';
import Photos from './Photos';
import { CollapsibleNote } from '../../../shared/DetailsCard';

export interface OrderDetailsCardRow {
  label: string;
  value: React.ReactNode;
}

const deliveryDetails = (t: TFunction, visit: VisitDtoModelType, stopUuid?: string): OrderDetailsCardRow[] => {
  const attemptForStop = visit.attempt(stopUuid);

  const deliveryAttemptTitle = () => {
    if (visit.isMissed(stopUuid) && attemptForStop?.date) {
      return t('orderDetails.attemptedOn');
    }
    if (visit.isCompleted && attemptForStop?.date) {
      return t('orderDetails.deliveredOn');
    }
    return '';
  };

  const hasPhotos = attemptForStop?.photos && attemptForStop.photos.length > 0;
  const hasSignature = !!attemptForStop?.signature;
  const proofOfDeliveryValue =
    hasPhotos || hasSignature ? (
      <>
        {hasPhotos && <Photos log={attemptForStop} />}
        {hasSignature && <Signature log={attemptForStop} />}
      </>
    ) : undefined;

  return [
    {
      label: t('orderDetails.scheduledTo'),
      value: visit.route ? <ScheduledTo visit={visit} stopUuid={stopUuid} /> : undefined,
    },
    {
      label: deliveryAttemptTitle(),
      value: attemptForStop?.formattedDateTime,
    },
    {
      label: t('orderDetails.missedReason'),
      value: attemptForStop?.reason ? <CollapsibleNote value={attemptForStop.reason} /> : undefined,
    },
    {
      label: t('orderDetails.deliveryNote'),
      value: attemptForStop?.notes ? <CollapsibleNote value={attemptForStop.notes} /> : undefined,
    },
    {
      label: t('orderDetails.proofOfDelivery'),
      value: proofOfDeliveryValue,
    },
    {
      label: t('orderDetails.customerRating'),
      value: visit?.rating?.rate
        ? <CustomerRating rate={visit.rating.rate} comment={visit?.rating?.comment} />
        : undefined,
    },
  ];
};

export default deliveryDetails;
